// extracted by mini-css-extract-plugin
export var cartContainer = "_p2-4";
export var gray = "_p2-1";
export var itemContainer = "_p2-2";
export var itemDetails = "_p2-3";
export var strong = "_p2-0";